import React from "react"
import {Button} from "semantic-ui-react"
import PropTypes from "prop-types"

const ListActions = ( { list, product } ) => {
	return (
		<Button.Group className="pl2">
			<Button style={{border: "none", background: "none"}}
				icon="trash"
				onClick={() => {
					list.remove( product )
				}}
			/>
			<Button style={{border: "none", background: "none"}}
				icon="cart"
				onClick={() => {
					list.toCart( product )
				}}
			/>
		</Button.Group>
	)
}
export default ListActions

ListActions.propTypes = {
	list:    PropTypes.object,
	product: PropTypes.object,
}



// WEBPACK FOOTER //
// ./src/components/Product/ProductRowListAction.js